export default __webpack_public_path__ + "static/media/focus.0365e278.png";